import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

import {
  ROLE_PROOF_READER,
  ROLE_QA_EXPERT,
  ROLE_SYSTEM_ADMIN,
  ROLE_LSP,
} from '@/utils/const';

export default {
  mixins: [
    helpers.work_with_string,
  ],
  props: {
    item: {
      type: Object,
      required: true,
    },
    section: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      showComment: false,
      showInputs: false,
      typeHolderText: 'add',
      tab: '',

      roles: {
        'pr': ROLE_PROOF_READER,
        'qa': ROLE_QA_EXPERT,
        'lsp': ROLE_LSP,
      },

      params: {
        ReportID: Number(this.$route.params.id),
        ErrorCategoryID: '',
        CommentText: '',
        ErrorConclusionSectionID: '',
      },

      changeParamsId: '',

      isComment: false,

    };
  },
  computed: {
    abilityAddComment () {
      if (this.$store.getters.userRole === ROLE_QA_EXPERT ||
                this.$store.getters.userRole === ROLE_LSP ||
                this.$store.getters.userRole === ROLE_PROOF_READER) {
        return true;
      }

      return false;
    },

    abilityChangeTypeError () {
      if (this.$store.getters.userRole === ROLE_QA_EXPERT ||
                this.$store.getters.userRole === ROLE_SYSTEM_ADMIN) {
        return true;
      }

      return false;
    },

    showButtonAdd () {
      if (this.typeHolderText === 'add') {
        return !this.showComment ? '+ Add note' : '- Hide';
      }
      return '+ Add note';
    },
  },
  created () {
    this.holderComments();
  },
  methods: {
    /**
         * Method for testing
         */
    holderComments () {
      this.params.ErrorCategoryID = this.section.ID;
      this.params.ErrorConclusionSectionID = this.item.List[0].Section;

      if (this.item.Comments.length > 0) {
        this.createShortComment((item, index) => {
          if (index === 0) {
            this.tab = item.UserData.Role;
          }
        });
      }
    },

    /**
         * Method for create short comments
         */
    createShortComment (callback) {
      this.item.Comments.forEach((item, index) => {
        const parseText = this.parseString(item.CommentText, 20);

        this.$set(item, 'CommentTextShort', parseText);
        this.$set(item, 'CommentTextView', parseText !== '' ? 'short' : 'long');

        if (item.UserData.Role === this.$store.getters.userRole) {
          this.isComment = true;
        }

        if (callback) {
          callback(item, index);
        }
      });
    },

    /**
         * Method for add in store error conclusions id
         */
    addToErrorConclusionList (id) {
      const errorCustomer = this.$store.getters.getDataSendCustomer;

      if (errorCustomer.ErrorConclusionList.find((item) => item === id) === undefined) {
        errorCustomer.ErrorConclusionList.push(id);
        this.$store.dispatch('REPORTS_DATA_CUSTOMER_UPDATE', errorCustomer);
      } else {
        const newList = errorCustomer.ErrorConclusionList.filter((item) => item !== id);

        errorCustomer.ErrorConclusionList = newList;
        this.$store.dispatch('REPORTS_DATA_CUSTOMER_UPDATE', errorCustomer);
      }
    },

    /**
         * Send data
         */
    changeMessage () {
      const params = {
        ID: this.changeParamsId,
        ...this.params,
      };
      this.showComment = false;
      Api.reports
        .changeCommentErrorConclusion(params)
        .then((data) => {
          if (data.data.Status) {
            this.$root.$emit('notification', {
              message: 'Message is was updated',
              type: 'info',
              show: true,
            });

            this.item.Comments.forEach((item) => {
              if (item.ID === params.ID) {
                item.CommentText = params.CommentText;
              }
            });

            this.createShortComment();
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Method for save messsage
         */
    addMessage () {
      Api.reports
        .addCommentErrorConclusion(this.params)
        .then((data) => {
          this.showComment = false;

          if (data.data.Status) {
            this.$root.$emit('notification', {
              message: 'Message is was added',
              type: 'info',
              show: true,
            });

            this.item.Comments.push(data.data.Data);
            this.holderComments();
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Method for change tab in comment list
         */
    changeTabRoleComment (comment) {
      this.tab = comment.UserData.Role;
      this.params.CommentText = '';
    },

    /**
         * Method for show short name role
         */
    showShortRole (nameRole) {
      for (const [name, value] of Object.entries(this.roles)) {
        if (value === nameRole) {
          return name;
        }
      }
    },

    /**
         * Show comment text
         */
    showCommentText (commet) {
      commet.CommentTextView === 'short' ? commet.CommentTextView = 'long' : commet.CommentTextView = 'short';
    },

    /**
         * Show form for add comment
         */
    showFormComment (type, tab) {
      this.showComment = !this.showComment;
      this.typeHolderText = type;
      this.typeHolderText === 'change' ? this.params.CommentText = tab.CommentText : this.params.CommentText = '';
      if (tab) {
        this.changeParamsId = tab.ID;
      }
    },

    /**
         * This method is nessesary, because name diff
         */
    checkRoleComment (commentTab) {
      if (commentTab.UserData.Role === this.$store.getters.userRole ||
                commentTab.UserData.Role === this.$store.getters.userRole) {
        return true;
      }

      return false;
    },

    /**
         * Method for update selected items
         */
    changeErrorConclusionItem (list) {
      Api.reports
        .changeErrorConclusionItem(Number(this.$route.params.id), list)
        .then((data) => {
          this.showInputs = false;

          if (data.data.Status) {
            this.$root.$emit('notification', {
              message: 'Changes have been saved!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

  },
};
